import { gql } from '@apollo/client';

export const TRANSLATED_ENTRY_FRAGMENT = gql`
  fragment TranslatedEntryFragment on TranslatedEntry {
    locale
    text
  }
`;
